/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizeraboutenai3Inputs */

const en_organizeraboutenai3 = /** @type {(inputs: Organizeraboutenai3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create with AI`)
};

const de_organizeraboutenai3 = /** @type {(inputs: Organizeraboutenai3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit KI erstellen`)
};

/**
* | output |
* | --- |
* | "Create with AI" |
*
* @param {Organizeraboutenai3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizeraboutenai3 = /** @type {((inputs?: Organizeraboutenai3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizeraboutenai3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizeraboutenai3(inputs)
	return de_organizeraboutenai3(inputs)
});
export { organizeraboutenai3 as "organizerAboutEnAi" }